import { _ as _getNative } from "./auth-service-tools1247.js";
import { _ as _root } from "./auth-service-tools993.js";
var getNative = _getNative,
    root = _root;
var Promise$1 = getNative(root, "Promise");
var _Promise = Promise$1;
export { _Promise as _ };